export type NotificationType = "success" | "error";

interface Notification {
  id: number;
  type: NotificationType;
  message: string;
}

type Listener<T> = (value: T) => void;

let activeRequests = 0;
let nextNotificationId = 0;
const loadingListeners: Listener<boolean>[] = [];
const notificationListeners: Listener<Notification>[] = [];

export function onLoadingChange(fn: Listener<boolean>) {
  loadingListeners.push(fn);
  return () => {
    const i = loadingListeners.indexOf(fn);
    if (i >= 0) loadingListeners.splice(i, 1);
  };
}

export function onNotification(fn: Listener<Notification>) {
  notificationListeners.push(fn);
  return () => {
    const i = notificationListeners.indexOf(fn);
    if (i >= 0) notificationListeners.splice(i, 1);
  };
}

export function requestStarted() {
  activeRequests++;
  if (activeRequests === 1) {
    loadingListeners.forEach((fn) => fn(true));
  }
}

export function requestEnded() {
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests === 0) {
    loadingListeners.forEach((fn) => fn(false));
  }
}

export function notify(type: NotificationType, message: string) {
  const notification: Notification = {
    id: nextNotificationId++,
    type,
    message,
  };
  notificationListeners.forEach((fn) => fn(notification));
}

export type { Notification };
